import { getLocationData } from 'api/commonSlice'
import BasicModal from 'components/Modal'
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import SoftBox from 'components/SoftBox';
import SoftButton from 'components/SoftButton';
import SoftTypography from 'components/SoftTypography';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { baseURL } from 'utils/api';
import toast from 'react-hot-toast';

const ApplyModal = ({ show, unShow, values, description }) => {

  const [data, setData] = useState([]);
  const id = localStorage.getItem("id");
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        fetch(`${baseURL}profile/getBranches?userId=${id}`)
          .then((res) => res.json())
          .then((res) => {
            if (res.status) {
              setData(res?.profile);
            }
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const handleSelectAll = (event) => {
    setSelectAll(event.target.checked);
    if (event.target.checked) {
      setSelectedLocations(data.map((location) => location._id));
    } else {
      setSelectedLocations([]);
    }
  };

  const handleLocationChange = (event) => {
    const locationId = event.target.value;
    if (event.target.checked) {
      setSelectedLocations([...selectedLocations, locationId]);
    } else {
      setSelectedLocations(selectedLocations.filter((id) => id !== locationId));
    }
  };

  const handelSubmit = () => {
    const body = {
      branchIds: selectedLocations,
      description: description,
      keywords: values.keywords,
      fbLink: values.fbLink,
      instagramLink: values.instagramLink,
      website: values.website,
    };

    fetch(`${baseURL}profile/updateMultipleBranches`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(body)
    })
      .then(res => res.json())
      .then(data => {
        if(data.status==200){
          toast.success(data.message);  
          setSelectedLocations([]);
          unShow(false);
        } 
        
      })
      .catch(err => {
        toast.error(err.message || 'Something went wrong');;
      })
  }



  return (

    <BasicModal show={show} unShow={unShow}>
      <SoftBox p={2}>
        <SoftTypography variant="caption">
          Note: Description, Keywords, Social Media Links (Option to selection location for apply changes).
        </SoftTypography>

        <SoftBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mt: 2,
            mb: 3
          }}
        >
          <SoftTypography variant="h6">Select Locations</SoftTypography>

          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={selectAll} onChange={handleSelectAll} />}
              label="Select All"
            />
            {data&&data.length>0&&data.map((location, i) => (
              <FormControlLabel
                key={location._id}
                control={
                  <Checkbox
                    checked={selectedLocations.includes(location._id)}
                    onChange={handleLocationChange}
                    value={location._id}
                  />
                }
                label={(location.firstName||'N/A') +"/"+(location?.locationName||'N/A') }
              />
            ))}
          </FormGroup>
        </SoftBox>

        <SoftBox sx={{ mt: 4 }}
          display="flex"
          justifyContent="space-between"
          gap={2}
        >
          {/* <Button variant="gradient" color="info">
            Save Changes
          </Button> */}
          <SoftButton variant="outlined" color="info"
            onClick={() => unShow(false)}
            fullWidth
          >
            Cancel
          </SoftButton>
          <SoftButton
            fullWidth
            variant="gradient"
            color="info"
            sx={{ color: 'white', marginRight: 2 }}
            onClick={() => handelSubmit()}
          >
            Apply changes
          </SoftButton>
        </SoftBox>
      </SoftBox>

    </BasicModal>
  );
}

export default ApplyModal;

